import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Water Source List with Query (for remote operations)
export const getWaterSourceListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_SOURCES}?${stringifyParams(
			params
		)}`
	);
};

// Get Water Source List with Query
export const getWaterSourceList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
        // populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_SOURCES}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Water Source
export const getWaterSource = water_source_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_SOURCE}${water_source_id}`
	);
};

// Add New Water Source
export const addNewWaterSourceApi = water_source => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_WATER_SOURCE}`,
		water_source
	);
};

// Update Water Source
export const updateWaterSourceApi = water_source => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_WATER_SOURCE}${water_source._id}`,
		water_source
	);
};

// Delete Water Source
export const deleteWaterSourceApi = water_source_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_WATER_SOURCE}${water_source_id}`
	);
};

// Check if Water Source Exists
export const checkWaterSourceExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_WATER_SOURCE_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
